import Vue from "vue";
console.log("-------------------reg.enroll.grid.js--------------------");
// 항목 필드 컴포넌트
const ItemCheckComponent = Vue.component("ItemCheckComponent", {
  data: function() {
    return {
      checked: true,
      item: ''
    };
  },

  mounted() {
    this.checked = this.params.data.checked;
    this.item = this.params.data.item;
  },

  watch: {
    checked() {
      this.params.data.checked = this.checked
      console.log(
        "this.params.context.componentParent",
        this.params.context.componentParent
      );
    }
  },

  template: '<div><input type="checkbox" v-model="checked" /> <span class="ml-20">{{item}} </span> </div>',
});

// 입력 필드 컴포넌트 (언어, 과정명, 레벨, 장소, 강사, 교육비, 교재비, 선착순, 대기자)
const InputComponent = Vue.component("InputComponent", {
  data: function() {
    return {
      text: '',
      type: '',
      id: '',
      isPrice: false
    };
  },  

  mounted() {
    console.log('input test')
    this.text = this.params.value
    this.type = this.params.colDef.field
    this.id = this.params.colDef.field + this.params.data.index.toString() + this.params.context.componentParent.idxOfChange + this.params.rowIndex.toString()

    if (this.params.colDef.field === 'eduPrice' || this.params.colDef.field === 'bookPrice') {
      this.isPrice = true
    }
  },

  watch: {
    text () {
      this.params.data[this.type] = this.text
    }
  },

  methods: {    
        // 한글, 영어, 특수문자 막기
        onlyNumber() {
          this.text = this.text.replace(/[^0-9]/g, '')
      }
  },

  template: '<div><input v-if="isPrice" type="text" :id="id" class="w-80px" v-model="text" @keyup="onlyNumber()" @change="onlyNumber()" /><input v-else type="text" :id="id" class="w-80px" v-model="text"/></div>',
});

// 요일 필드 컴포넌트
const DateComponent = Vue.component("DateComponent", {
  data: function() {
    return {
      value: ''
    };
  },

  mounted() {
    this.value = this.params.value
  },

  watch: {
    'params.data.day' () {
      this.value = this.params.data.day
    }
  },

  methods: {
    openModal() {
      var datas = {
        type: 'day',
        opened: true,
        gridIndex: this.params.data.index,
        rowIndex: this.params.node.childIndex
      }
      this.$EventBus.$emit('enrollPopup', datas)
    },

    replaceDate () {
      var date = this.value.replace(/\^/gi, ',')
      console.log('호출')
      return date
    }
  },

  template: '<div><button type="button" v-if="value === \'\'" @click="openModal()" data-toggle="modal" data-target="#enrollDate">선택</button><div v-else class="txt-center"><div class="h-20px"><span>{{replaceDate()}}</span></div><button type="button" style="padding: 1px 15px" class="bg-lg" @click="openModal()" data-toggle="modal" data-target="#enrollDate">수정</button></div></div>',
});

//  교육시간 컴포넌트
const TimeComponent = Vue.component("TimeComponent", {
  data: function() {
    return {
      value: ''
    };
  },

  mounted() {
    if (this.params.data.subjectStartTime !== '' && 
    this.params.data.subjectEndTime !== '') {
      this.value = this.params.data.subjectStartTime + ' ~ ' + this.params.data.subjectEndTime
    }
  },

  watch: {
    'params.data.subjectStartTime' () {
      this.value = this.params.data.subjectStartTime + ' ~ ' + this.params.data.subjectEndTime
    },

    'params.data.subjectEndTime' () {
      this.value = this.params.data.subjectStartTime + ' ~ ' + this.params.data.subjectEndTime
    }
  },

  methods: {
    openModal() {
      var datas = {
        type: 'time',
        opened: true,
        gridIndex: this.params.data.index,
        rowIndex: this.params.node.childIndex
      }
      this.$EventBus.$emit('enrollPopup', datas)
    }
  },

  template: '<div><button type="button" v-if="value === \'\'" @click="openModal()" data-toggle="modal" data-target="#enrollTime">선택</button><div v-else class="txt-center"><div class="h-20px"><span>{{value}}</span></div><button type="button" style="padding: 1px 15px" class="bg-lg" @click="openModal()" data-toggle="modal" data-target="#enrollTime">수정</button></div></div>',
});

//  상세 및 기타 컴포넌트
const DetailComponent = Vue.component("DetailComponent", {
  data: function() {
    return {
      value: ''
    };
  },

  mounted() {
    this.value = this.params.value
    this.subjectName = this.params.data.subjectName
  },

  watch: {
    'params.data.etc' () {
      this.value = this.params.data.etc
      this.subjectName = this.params.data.subjectName
    }
  },

  methods: {
    openModal() {
      var datas = {
        type: 'detail',
        opened: true,
        gridIndex: this.params.data.index,
        rowIndex: this.params.node.childIndex
      }
      this.$EventBus.$emit('enrollPopup', datas)
    }
  },

  template: '<div><button type="button" v-if="value === \'\'" @click="openModal()" data-toggle="modal" data-target="#enrollDetail">선택</button><button type="button" class="bg-lg" v-else @click="openModal()" data-toggle="modal" data-target="#enrollDetail">수정</button></div>',
});

export { ItemCheckComponent, InputComponent, DateComponent, TimeComponent, DetailComponent };
